export interface OAuthStatusResponse {
  instagram: OauthStatusType
  tiktok: OauthStatusType
  youtube: OauthStatusType
  instagramBasic: OauthStatusType
}

export enum OAuthQueryKeys {
  GENERAL_STATUS = 'GENERAL_STATUS',
  CONNECTION_LINK = 'CONNECTION_LINK',
}

export interface OauthLinkResponse {
  url: string
}

export enum OAuthConnectionType {
  INSTAGRAM = 'instagram',
  TIKTOK = 'tiktok',
  YOUTUBE = 'youtube',
  INSTAGRAM_BASIC = 'instagram-basic',
}

export enum OauthRequestSocialType {
  INSTAGRAM = 'instagram',
  TIKTOK = 'tiktok',
  YOUTUBE = 'youtube',
  INSTAGRAM_BASIC = 'instagram-basic',
}

export enum OauthStatus {
  CONNECTED = 'connected',
  EXPIRED = 'expired',
  DISCONNECTED = 'disconnected',
}

export type OauthStatusType = OauthStatus | null
